var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"text-uppercase px-2"},[_vm._v(" Dashboard ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }